<template>
  <div
    :class="showAbove ? 'tw-bottom-full tw-mb-2' : 'tw-top-full tw-mt-2'"
    class="
      tw-absolute
      -tw-right-0.5
      tw-z-50 tw-bg-white tw-rounded-lg tw-shadow-lg
      !tw-border-2 !tw-border-solid !tw-border-amber-500
      tw-p-3 tw-w-60
    "
    data-testid="adjust-forecast-value-modal"
    @mousedown.stop
  >
    <div class="tw-grid tw-grid-cols-3 tw-gap-2 tw-mb-2">
      <SfButtonDs
        v-for="pct in quickPercentages"
        :key="pct"
        variant="secondary"
        :disabled="props.disablePercentages"
        :class="[
          'tw-w-full',
          pct === roundedAdjustmentPercentage
            ? '!tw-border-2 !tw-border-amber-500'
            : '',
        ]"
        :data-testid="`quick-pct-${pct}`"
        @click.stop="props.onApplyPercentage(pct)"
      >
        {{ pct > 0 ? `+${pct}%` : `${pct}%` }}
      </SfButtonDs>
    </div>

    <div class="tw-text-xs tw-text-sf-slate-light-2 tw-mb-2 tw-text-left">
      {{ copy.calculationsHint }}
    </div>

    <div class="tw-flex tw-items-baseline tw-gap-2 tw-mb-2">
      <kbd
        class="
          tw-border
          tw-border-solid
          tw-border-sf-neutral-lighter-1
          tw-rounded-md
          tw-px-1.5
          tw-py-px
          tw-font-bold
          tw-bg-sf-slate-subtle-1
          tw-text-sf-slate-light-2
          tw-text-[10px]
        "
        >ENTER</kbd
      >
      <span class="tw-text-xs tw-text-sf-slate">{{ copy.save }}</span>
      <kbd
        class="
          tw-border
          tw-border-solid
          tw-border-sf-neutral-lighter-1
          tw-rounded-md
          tw-px-1.5
          tw-py-px
          tw-font-bold
          tw-bg-sf-slate-subtle-1
          tw-text-sf-slate-light-2
          tw-ml-2
          tw-text-[10px]
        "
        >TAB</kbd
      >
      <span class="tw-text-xs tw-text-sf-slate">{{ copy.next }}</span>
    </div>

    <hr class="tw-border-sf-slate-lighter-1 tw-mt-1 tw-mb-3" />

    <SfButtonDs
      variant="tertiary"
      class="tw-w-full tw-justify-center"
      @click.stop="props.onReset()"
    >
      {{ copy.resetButton }}
    </SfButtonDs>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import useI18n from '@app/shared/vue/composables/use-I18n'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

const quickPercentages = [5, 10, 20, -5, -10, -20]

const props =
  defineProps<{
    anchorEl: HTMLElement
    adjustmentPercentage: number | null
    disablePercentages: boolean
    onApplyPercentage: (pct: number) => void
    onReset: () => void
  }>()

const I18n = useI18n()

const copy = {
  calculationsHint: I18n.t(
    'reports.forecast.adjust_value.modal.calculations_hint'
  ),
  save: I18n.t('reports.forecast.adjust_value.modal.save'),
  next: I18n.t('reports.forecast.adjust_value.modal.next'),
  resetButton: I18n.t('reports.forecast.adjust_value.modal.reset_button'),
}

const roundedAdjustmentPercentage = computed(() =>
  props.adjustmentPercentage !== null
    ? Math.round(props.adjustmentPercentage)
    : null
)

const showAbove = computed(() => {
  const container = document.querySelector('[data-behaviour="report-table"]')!
  const containerRect = container.getBoundingClientRect()
  const anchorRect = props.anchorEl.getBoundingClientRect()
  return (
    anchorRect.top - containerRect.top >
    containerRect.bottom - anchorRect.bottom
  )
})
</script>
